<template>
  <v-container fluid>

    <v-layout row wrap>
      <v-flex xs4>
        <add-technical-parameter :typology-id="typology.id"
                                 v-on:technical-parameter-added="technicalParamterAdded($event)">
        </add-technical-parameter>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="typology.technical_parameters"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.type }}</td>
            <td class="text-xs-center">{{ props.item.porte_p || 'Não Parametrizado' }}</td>
            <td class="text-xs-center">
              <remove-technical-parameter :typology="typology"
                                          :technical-parameter-id="props.item.id"/>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import AddTechnicalParameter from '@/components/configurations/typology/show/technical_parameter/add_technical_parameter/AddTechnicalParameter';
import RemoveTechnicalParameter from '@/components/configurations/typology/show/technical_parameter/remove/RemoveTechnicalParameterComponent';

export default {
  name: 'TechnicalParametersComponent',
  props: ['typology'],
  components: {
    AddTechnicalParameter,
    RemoveTechnicalParameter,
  },
  mounted() {
  },
  data() {
    return {
      headers: [
        { text: 'Parâmetro Técnico', value: 'technical_parameter', align: 'center' },
        { text: 'Tipo', value: 'type', align: 'center' },
        { text: 'Valor Máximo do Porte P', value: 'porte_p', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' }],
      valid: false,
    };
  },
  methods: {
    technicalParamterAdded(event) {
      this.typology.technical_parameters.push(event);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
